/* eslint-disable import/no-unresolved */
import React, { useRef, useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/free-mode'
import { Container, Image } from 'react-bootstrap'
import {
  sample_01,
  sample_02,
  sample_03,
  sample_04,
  sample_05,
  sample_06,
  sample_07,
  logoFullX,
} from '../asset'

function Mainpage() {
  const [activeIndex, setActiveIndex] = useState(0)
  const swiperRef = useRef(null)
  const videoRefs = useRef([])

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex)
    swiper.slideTo(swiper.activeIndex, 500, false)

    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === swiper.activeIndex) {
          video
            .play()
            .then(() => {})
            .catch((error) => console.warn('Autoplay prevented:', error))
        } else {
          video.pause()
          setTimeout(() => {
            if (video) {
              const tempVideo = video
              tempVideo.currentTime = 0
            }
          }, 500)
        }
      }
    })
  }

  useEffect(() => {
    const playVideo = () => {
      requestAnimationFrame(() => {
        const video = videoRefs.current[1]
        if (video) {
          video.muted = true
          video.setAttribute('playsinline', '')
          video.setAttribute('autoplay', 'true')
          video.setAttribute('loop', 'true')
          video.setAttribute('playsinline', '')
          video.setAttribute('autoplay', 'true')
          video.setAttribute('playsinline', '')
          video
            .play()
            .then(() => {})
            .catch((error) => console.warn('Autoplay prevented:', error))
        }
      })
    }

    setTimeout(playVideo, 500)

    window.addEventListener('focus', playVideo)
    return () => window.removeEventListener('focus', playVideo)
  }, [])

  return (
    <Container className="bg-light">
      <Image className="pt-3" style={{ height: '8%' }} src={logoFullX} />
      <h3 className="m-auto pt-3" style={{ height: '5%' }}>
        協助建立專屬於你的創意廣告版面
      </h3>
      <small className="mb-auto">左右拖曳可切換不同版面進行預覽</small>
      <Swiper
        ref={swiperRef}
        spaceBetween={30}
        slidesPerView="auto"
        centeredSlides
        autoplay
        freeMode={false}
        onSlideChange={handleSlideChange}
        initialSlide={2}
        className="custom-swiper-homepage"
        style={{ overflow: 'hidden', height: '85%' }}
      >
        {[
          sample_01,
          sample_06,
          sample_07,
          sample_02,
          sample_03,
          sample_04,
          sample_05,
        ].map((videoSrc, index) => (
          <SwiperSlide
            key={index}
            className={`custom-slide-homepage ${
              index === activeIndex ? 'active' : ''
            }`}
            style={{ cursor: 'grab' }}
            onClick={() => {
              if (swiperRef.current && swiperRef.current.swiper) {
                swiperRef.current.swiper.slideTo(index, 500, false)
                setTimeout(() => {
                  swiperRef.current.swiper.update()
                }, 100)
              }
            }}
          >
            <video
              ref={(el) => {
                if (el) videoRefs.current[index] = el
              }}
              muted
              loop
              autoPlay
              className="video-player-main"
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}

export default Mainpage
